import React from "react";
import {CatalogService} from "../../../service/catalog/CatalogService";
import PresvalDropDown from "../PresvalDropDownView";


export default class InstitutionDropDownContainer extends React.Component {
    constructor(props) {
        super(props);
        this.catalogService = new CatalogService();

        this.getInstitutionCatalog = this.getInstitutionCatalog.bind(this);

        this.state = {
            catInstitutionCatalog: this.getInstitutionCatalog(),
        };
    }

    getInstitutionCatalog() {
        this.catalogService.getInstitutionCatalog().then(
            res => {
                this.setState({
                    catInstitutionCatalog: res,
                });
                this.props.loading(false);
            }
        )
    }

    render() {
        return <PresvalDropDown
            name={this.props.name}
            filter={this.props.filter}
            options={this.state.catInstitutionCatalog}
            save={this.props.save}
            value={this.props.value}
            disabled={this.props.disabled}
            tabIndex={this.props.tabIndex}
            placeholder={this.props.placeholder ? this.props.placeholder : "Seleccione..."}
        />
    }
};